<div class="flex align-items-center">
  <crm-user-avatar [user]="userGroup"></crm-user-avatar>
  <div class="flex flex-column ml-2">
    <div class="font-medium">{{ userGroup.name }}</div>
    <div class="text-sm text-400">Участников: {{ userGroup.users?.length || 0 }}</div>
  </div>
</div>
